import React, { Suspense, lazy, useCallback, useState } from "react";
import { CalendarDays, CalendarRange } from "lucide-react";
import { fetchLatestReport } from "@/lib/api";

const ReportViewer = lazy(() => import("@/components/ReportViewer"));

const BTN = "inline-flex items-center gap-1 sm:gap-1.5 px-2 sm:px-3 py-1.5 font-sub text-[10px] sm:text-[11px] uppercase tracking-[0.12em] sm:tracking-[0.16em] font-bold rounded-sm transition-colors whitespace-nowrap";

// Two public header buttons that open the latest auto-generated reports.
export const ReportButtons = () => {
    const [period, setPeriod] = useState(null);
    const load = useCallback(() => fetchLatestReport(period), [period]);
    return (
        <div className="flex items-center gap-1.5 shrink-0" data-testid="report-buttons-bar">
            <button onClick={() => setPeriod("daily")} data-testid="daily-report-btn" title="Daily Report"
                className={`${BTN} bg-black text-white hover:bg-[#0FA95A]`}>
                <CalendarDays className="w-3.5 h-3.5" /> Daily<span className="hidden lg:inline">&nbsp;Report</span>
            </button>
            <button onClick={() => setPeriod("weekly")} data-testid="weekly-report-btn" title="Weekly Report"
                className={`${BTN} bg-[#22E578] text-black hover:bg-black hover:text-[#22E578]`}>
                <CalendarRange className="w-3.5 h-3.5" /> Weekly<span className="hidden lg:inline">&nbsp;Report</span>
            </button>
            {period && (
                <Suspense fallback={null}>
                    <ReportViewer open={!!period} onOpenChange={(o) => !o && setPeriod(null)} period={period} loadReport={load} hideScores />
                </Suspense>
            )}
        </div>
    );
};
